module.exports = __webpack_public_path__ + "img/share_files.bbad0dc2.svg";